{
  "AGENT_BOTS": {
    "HEADER": "Botai",
    "LOADING_EDITOR": "Įkeliama redagavimo priemonė...",
    "DESCRIPTION": "Agent Bots are like the most fabulous members of your team. They can handle the small stuff, so you can focus on the stuff that matters. Give them a try. You can manage your bots from this page or create new ones using the 'Add Bot' button.",
    "LEARN_MORE": "Learn about agent bots",
    "COUNT": "{n} bot | {n} bots",
    "SEARCH_PLACEHOLDER": "Search bots...",
    "NO_RESULTS": "No bots found matching your search",
    "GLOBAL_BOT": "System bot",
    "GLOBAL_BOT_BADGE": "Sistema",
    "AVATAR": {
      "SUCCESS_DELETE": "Bot avatar deleted successfully",
      "ERROR_DELETE": "Error deleting bot avatar, please try again"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Pasirinkite agento botą",
      "DESC": "Assign an Agent Bot to your inbox. They can handle initial conversations and transfer them to a live agent when necessary.",
      "SUBMIT": "Atnaujinti",
      "DISCONNECT": "Atsijungti Botą",
      "SUCCESS_MESSAGE": "Sėkmingai atnaujintas agento botas.",
      "DISCONNECTED_SUCCESS_MESSAGE": "Sėkmingai atjungtas agento botas.",
      "ERROR_MESSAGE": "Nepavyko atnaujinti agento boto. Bandykite dar kartą vėliau.",
      "DISCONNECTED_ERROR_MESSAGE": "Nepavyko ajungti agento boto. Bandykite dar kartą vėliau.",
      "SELECT_PLACEHOLDER": "Pasirinkti Botą"
    },
    "ADD": {
      "TITLE": "Add Bot",
      "CANCEL_BUTTON_TEXT": "Atšaukti",
      "API": {
        "SUCCESS_MESSAGE": "Botas pridėtas sėkmingai.",
        "ERROR_MESSAGE": "Nepavyko pridėti boto. Bandykite dar kartą vėliau."
      }
    },
    "LIST": {
      "404": "No bots found. You can create a bot by clicking the 'Add Bot' button.",
      "LOADING": "Gaunami Botai...",
      "TABLE_HEADER": {
        "DETAILS": "Bot Details",
        "URL": "Webhook URL",
        "ACTIONS": "Veiksmai"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Ištrinti",
      "TITLE": "Ištrinti Botą",
      "CONFIRM": {
        "TITLE": "Patvirtinti Ištrynimą",
        "MESSAGE": "Are you sure you want to delete {name}?",
        "YES": "Taip, Ištrinti",
        "NO": "Ne, Išsaugoti"
      },
      "API": {
        "SUCCESS_MESSAGE": "Botas ištrintas sėkmingai.",
        "ERROR_MESSAGE": "Nepavyko ištrinti boto. Bandykite dar kartą."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Redaguoti",
      "TITLE": "Keisti Botą",
      "API": {
        "SUCCESS_MESSAGE": "Botas atnaujintas sėkmingai.",
        "ERROR_MESSAGE": "Nepavyko atnaujinti boto. Bandykite dar kartą vėliau."
      }
    },
    "SECRET": {
      "LABEL": "Webhook Secret",
      "COPY": "Copy secret to clipboard",
      "COPY_SUCCESS": "Secret copied to clipboard",
      "TOGGLE": "Toggle secret visibility",
      "CREATED_DESC": "Use the secret below to verify webhook signatures. Please copy it now, you can also find it later in the bot settings.",
      "DONE": "Done",
      "RESET_SUCCESS": "Webhook secret regenerated successfully",
      "RESET_ERROR": "Unable to regenerate webhook secret. Please try again"
    },
    "ACCESS_TOKEN": {
      "TITLE": "Prieeigos raktas",
      "DESCRIPTION": "Copy the access token and save it securely",
      "COPY_SUCCESSFUL": "Access token copied to clipboard",
      "RESET_SUCCESS": "Access token regenerated successfully",
      "RESET_ERROR": "Unable to regenerate access token. Please try again"
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Bot avatar"
      },
      "NAME": {
        "LABEL": "Boto Pavadinimas",
        "PLACEHOLDER": "Enter bot name",
        "REQUIRED": "Yra reikalingas Boto vardas"
      },
      "DESCRIPTION": {
        "LABEL": "Aprašymas",
        "PLACEHOLDER": "Ką daro šis botas?"
      },
      "WEBHOOK_URL": {
        "LABEL": "Webhook URL",
        "PLACEHOLDER": "https://example.com/webhook",
        "REQUIRED": "Webhook URL is required"
      },
      "ERRORS": {
        "NAME": "Yra reikalingas Boto vardas",
        "URL": "Webhook URL is required",
        "VALID_URL": "Please enter a valid URL starting with http:// or https://"
      },
      "CANCEL": "Atšaukti",
      "CREATE": "Create Bot",
      "UPDATE": "Update Bot"
    },
    "WEBHOOK": {
      "DESCRIPTION": "Configure a webhook bot to integrate with your custom services. The bot will receive and process events from conversations and can respond to them."
    },
    "TYPES": {
      "WEBHOOK": "Boto Webhook"
    }
  }
}
